import React from 'react';
import Weblayout from './Weblayout';
import PageTransition from '../components/PageTransition';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { appname } from "../variables";

export default function Mandate() {
  const navigate = useNavigate();

  return (
    <PageTransition>
      <Weblayout isLegal={true}>
        <motion.div 
          initial={{ opacity: 0, scale: 0.98 }}
          animate={{ opacity: 1, scale: 1 }}
          className="bento-item p-0 border-0 bg-white overflow-hidden d-flex flex-column h-100 shadow-lg"
          style={{ borderRadius: '24px' }}
        >
          {/* STICKY DOCUMENT HEADER */}
          <div className="bg-light border-bottom p-4 flex-shrink-0 d-flex justify-content-between align-items-center">
            <div>
              <h2 className="fw-black text-dark m-0">Mandate Policies</h2>
              <small className="text-muted font-monospace">INTERNAL_REF: LEGAL_MAND_2026_V1</small>
            </div>
            <div className="badge bg-primary bg-opacity-10 text-primary border border-primary border-opacity-25 px-3 py-2">
              <i className="bi bi-file-earmark-check me-1"></i> COMPLIANCE_ACTIVE
            </div>
          </div>

          {/* SCROLLABLE CONTENT BODY */}
          <div className="p-4 p-md-5 overflow-auto text-dark privacy-content flex-grow-1">
            
            <section className="mb-5">
              <h6 className="font-monospace text-primary fw-bold mb-2">01_SERVICE_SCOPE</h6>
              <h4 className="fw-black text-dark mb-3">Operational Mandate</h4>
              <p>
                As a platform operated by <strong>Indian Technology Company</strong>, {appname} is mandated to provide secure API bridging services. This document outlines the legal requirements and service boundaries that govern our relationship with end-users and regulatory bodies.
              </p>
            </section>

            <section className="mb-5">
              <h6 className="font-monospace text-primary fw-bold mb-2">02_REGULATORY_COMPLIANCE</h6>
              <h4 className="fw-black text-dark mb-3">Statutory Alignment</h4>
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="p-3 bg-light rounded-3 border h-100">
                    <span className="fw-bold d-block text-primary mb-1 small">IT Act Compliance</span>
                    <p className="small text-muted m-0">Our systems are engineered to comply with the Information Technology Act, 2000 and subsequent Indian data protection amendments.</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="p-3 bg-light rounded-3 border h-100">
                    <span className="fw-bold d-block text-primary mb-1 small">KYC Protocols</span>
                    <p className="small text-muted m-0">Identity verification is mandatory for all enterprise nodes to prevent service misuse and maintain platform integrity.</p>
                  </div>
                </div>
              </div>
            </section>

            <section className="mb-5">
              <h6 className="font-monospace text-primary fw-bold mb-2">03_USER_OBLIGATIONS</h6>
              <h4 className="fw-black text-dark mb-3">The Usage Mandate</h4>
              <p>Users of the {appname} protocol are strictly mandated to adhere to the following logic:</p>
              <ul className="list-unstyled">
                <li className="mb-3 d-flex gap-2">
                  <i className="bi bi-shield-lock-fill text-primary"></i>
                  <span><strong>Auth Integrity:</strong> Users must maintain the security of their API keys and session tokens. <strong>Indian Technology Company</strong> is not liable for credential leaks on the user-side.</span>
                </li>
                <li className="mb-3 d-flex gap-2">
                  <i className="bi bi-broadcast-pin text-primary"></i>
                  <span><strong>Anti-Spam Directive:</strong> Users are prohibited from utilizing the node for bulk-spamming or unsolicited communication that violates Meta's global policies.</span>
                </li>
                <li className="mb-3 d-flex gap-2">
                  <i className="bi bi-geo-alt-fill text-primary"></i>
                  <span><strong>Jurisdiction:</strong> Any legal disputes are subject to the exclusive jurisdiction of the courts in <strong>Hooghly, West Bengal, India</strong>.</span>
                </li>
              </ul>
            </section>

            <section className="mb-5">
              <h6 className="font-monospace text-primary fw-bold mb-2">04_DATA_MANDATE</h6>
              <h4 className="fw-black text-dark mb-3">Retention & Requests</h4>
              <p>
                While we operate on a zero-persistence framework for message content, billing records and account metadata are retained for a period of <strong>7 years</strong> as mandated by Indian financial and tax regulations.
              </p>
            </section>

            <section className="mb-4">
              <div className="p-4 rounded-4 border border-2 border-dashed d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 text-center text-md-start">
                <div>
                  <h5 className="fw-bold m-0 text-dark">Need a signed compliance copy?</h5>
                  <small className="text-muted">Request a PDF version of our statutory mandates for your legal team.</small>
                </div>
                <button className="btn btn-outline-dark rounded-pill px-4 fw-bold" onClick={() => navigate('/support')}>
                  REQUEST_DOCUMENT
                </button>
              </div>
            </section>

          </div>
        </motion.div>
      </Weblayout>
    </PageTransition>
  );
}